// Signup Team Contentv2 Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import InputAlt from '../../form/input_alt/input_alt.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Alert from '../../common/alert/alert.jsx'
import Checkbox from '../../form/checkbox/checkbox.jsx'
import getUrlParameters from './getUrlParameters/getUrlParameters'

const CODE_TO_COUNTRY = {
  NL: 'The Netherlands',
  DE: 'Germany',
  UK: 'United Kingdom',
  US: 'United States'
}
const COUNTRY_TO_CODE = {
  'The Netherlands': 'NL',
  Germany: 'DE',
  'United Kingdom': 'UK',
  'United States': 'US'
}

class SignupTeamContentv2 extends Component {
  static get propTypes () {
    return {
      country: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
      onSubmit: PropTypes.func,
      checkUserExists: PropTypes.func,
      recaptchaEnabled: PropTypes.bool,
      onClickTerms: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      country: null,
      email: '',
      phone: '',
      onSubmit: null,
      checkUserExists: null,
      recaptchaEnabled: false,
      onClickTerms: null
    }
  }

  constructor (props) {
    super(props)

    const country = props.country ? props.country.toUpperCase() : 'NL'

    this.state = {
      companyName: '',
      country: country,
      companySize: '',
      firstName: '',
      lastName: '',
      email: props.email || '',
      phone: '',
      password: '',
      bUserExists: false,
      errInvite: '',
      userPassword: '',
      currStep: 1,
      contHgt: null,
      isButtonDisabled: false,
      bTermsAgree: false,
      bTermsAgreeError: false
    }

    this.data = {
      companySizeOptions: [
        { label: 'common.form.sizeOptionFirst', value: '1' },
        { label: 'common.form.sizeOptionSecond', value: '2-5' },
        { label: 'common.form.sizeOptionThird', value: '5-10' },
        { label: 'common.form.sizeOptionFour', value: '10-20' },
        { label: 'common.form.companySizeMore', value: '20-more' }
      ],
      countries: [
        { label: 'common.form.countryNederlands', value: 'NL' },
        { label: 'common.form.countryGermany', value: 'DE' },
        { label: 'common.form.countryEnglish', value: 'UK' },
        { label: 'common.form.countryUnitedStates', value: 'US' }
      ]
    }

    this._references = {
      alert: React.createRef(),
      inputCompanyName: React.createRef(),
      inputEmail: React.createRef(),
      inputPhone: React.createRef(),
      inputFirstName: React.createRef(),
      inputLastName: React.createRef(),
      inputPassword: React.createRef(),
      inputConfirmPassword: React.createRef(),
      inputUserPassword: React.createRef()
    }

    this._recaptcha = null
    this._recaptchaEnabled = !!this.props.recaptchaEnabled
    this.bFocus = false
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (this.state.currStep !== 3 && nextState.currStep === 3) {
      this.bFocus = true
    }

    return true
  }

  handleResize () {
    const minheight = this.getWindowHeight()
    this.setState({ contHgt: { height: minheight } })
  }

  componentDidUpdate () {
    this.setAutoFocus()
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleResize()

    if (this._references.inputCompanyName.current) {
      this._references.inputCompanyName.current.focus()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  getWindowHeight () {
    const windowHgt = window.innerHeight + 'px'

    return windowHgt
  }

  setAutoFocus () {
    if (this.bFocus) {
      this.bFocus = false

      if (this._references.inputPassword.current) {
        this._references.inputPassword.current.focus()
      }
    }
  }

  render () {
    const contentClass = classnames('invite-contentv2', {})

    return (
      <div className={contentClass} style={this.state.contHgt}>
        <div className='invitecontainerv2'>
          {this.state.errors?.termsAgree && (
            <div className='accept-terms-error'>
              <IntlMessage ident='user.signupTeamv2.mustAgreeTermsAndConditions' />
              <IconButton
                icon='header-search-close'
                canHover={false}
                onClick={() => this._onBlurField('termsAgree')}
              />
            </div>
          )}
          <div className='content'>
            <div className='header'>
              <img
                src='/images/common/rodeo_logo.svg'
                alt='Logo'
                className='logo'
              />
            </div>
            {this._renderForm()}
          </div>
        </div>
        <Alert ref={this._references.alert} />
      </div>
    )
  }

  showError (msgIdent) {
    this.setState({ isButtonDisabled: false })
    if (this._references.alert.current) {
      this._references.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'error'
      )
    }
  }

  hideError () {
    this.setState({ errInvite: '' })
  }

  /* Event Handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })
    this._onBlurField('termsAgree')
  }

  _onSubmitCompanyForm (ev) {
    ev.preventDefault()

    const refs = this._references

    const errors = {
      companyName: refs.inputCompanyName.current && !refs.inputCompanyName.current.validate(),
      firstName: refs.inputFirstName.current && !refs.inputFirstName.current.validate(),
      lastName: refs.inputLastName.current && !refs.inputLastName.current.validate(),
      email: refs.inputEmail.current && !refs.inputEmail.current.validate(),
      password: refs.inputPassword.current && !refs.inputPassword.current.validate(),
      termsAgree: !this.state.bTermsAgree
    }

    this.setState(prevStates => ({
      ...prevStates,
      errors
    }))

    const hasError = Object.values(errors).filter(error => error).length

    if (!hasError) {
      this.props.checkUserExists(this.state.email, bUserExists => {
        this._callSubmitSignup(bUserExists)
      })
    }
  }

  _callSubmitSignup (bUserExists) {
    this.setState({
      bUserExists: bUserExists,
      errInvite: '',
      isButtonDisabled: true
    })

    const country = this.state.country
    let language = 'EN'
    if (country === 'NL') {
      language = 'NL'
    } else if (country === 'DE') {
      language = 'DE'
    } else if (country === 'US') {
      language = 'US'
    }

    const inviteObj = {
      companyName: this.state.companyName,
      country: country,
      companySize: this.state.companySize,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      language: language,
      email: this.state.email,
      phone: this.state.phone,
      password: this.state.password,
      urlParameters: getUrlParameters(window.location.href)
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(inviteObj, bUserExists)
    }
  }

  _onCaptchaVerified (_token) {
    this._callSubmitSignup(this.state.bUserExists)
  }

  _onClickStep1 (ev) {
    ev.preventDefault()
    this.setState({ currStep: 1 })
  }

  _onClickStep2 (ev) {
    ev.preventDefault()
    this.setState({ currStep: 2 })
  }

  _onClickStep3 (ev) {
    ev.preventDefault()
    this.setState({ currStep: 3 })
  }

  _onClickStep4 (ev) {
    ev.preventDefault()
    this.setState({ bUserExists: false, currStep: 2 })
  }

  /* Private functions */
  _renderMessage (type, title, content, email) {
    const _clsNames = classnames('formmessage', {
      formmessage_error: type
    })

    return (
      <div className={_clsNames}>
        <h2 className='title'>
          <IntlMessage ident={title} />
        </h2>
        <p className='content'>
          <IntlMessage ident={content} />
          {email}
        </p>
      </div>
    )
  }

  _renderErrorMessage () {
    if (this.state.errInvite) {
      const msg = 'user.signupTeam.msgInviteError'
      return this._renderMessage('error', msg, this.state.errInvite, '')
    }

    return null
  }

  _onBlurField (name) {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: false
      }
    }))
  }

  _renderForm () {
    const { bTermsAgreeError, isButtonDisabled } = this.state
    const submitClasses = classnames('submit', {
      disabled: isButtonDisabled
    })

    return (
      <div className='inviteformv2'>
        <div className='formcontainer'>
          <div className='colform'>
            <form
              action='#'
              method='post'
              noValidate
              onSubmit={this._onSubmitCompanyForm.bind(this)}
            >
              <div className='typo'>
                <h1 className='title'>
                  <IntlMessage ident='user.signupTeamv2.signupTitle' />
                </h1>
              </div>
              <div className='formcontent'>
                <div className='formrow'>
                  <div className='formlabel'>
                    <IntlMessage ident='user.signupTeam.placeholderCompanyName' />
                    {this.state.errors?.companyName && (
                      <span className='errormsglabel'>
                        <IntlMessage ident='user.signupTeam.msgInvalidCompanyName' />
                      </span>
                    )}
                  </div>
                  <div className='formfield'>
                    <InputAlt
                      type='text'
                      name='company'
                      size={10}
                      maxLength={100}
                      ref={this._references.inputCompanyName}
                      required
                      validations={['required']}
                      value={this.state.companyName}
                      onChange={this._onChangeInput.bind(this, 'companyName')}
                      onBlur={this._onBlurField.bind(this, 'companyName')}
                      className={this.state.errors?.companyName ? 'errormsg' : ''}
                    />
                  </div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>
                    <IntlMessage ident='user.signupTeamv2.firstName' />
                    {this.state.errors?.firstName && (
                      <span className='errormsglabel'>
                        <IntlMessage ident='user.signupTeam.msgInvalidFirstName' />
                      </span>
                    )}
                  </div>
                  <div className='formfield'>
                    <InputAlt
                      type='text'
                      name='firstName'
                      size={10}
                      maxLength={100}
                      ref={this._references.inputFirstName}
                      required
                      validations={['required']}
                      value={this.state.firstName}
                      onChange={this._onChangeInput.bind(this, 'firstName')}
                      className={this.state.errors?.firstName ? 'errormsg' : ''}
                      onBlur={this._onBlurField.bind(this, 'firstName')}
                    />
                  </div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>
                    <IntlMessage ident='user.signupTeamv2.lastName' />
                    {this.state.errors?.lastName && (
                      <span className='errormsglabel'>
                        <IntlMessage ident='user.signupTeam.msgInvalidLastName' />
                      </span>
                    )}
                  </div>
                  <div className='formfield'>
                    <InputAlt
                      type='text'
                      name='lastName'
                      size={10}
                      maxLength={100}
                      ref={this._references.inputLastName}
                      required
                      validations={['required']}
                      value={this.state.lastName}
                      onChange={this._onChangeInput.bind(this, 'lastName')}
                      className={this.state.errors?.lastName ? 'errormsg' : ''}
                      onBlur={this._onBlurField.bind(this, 'lastName')}
                    />
                  </div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>
                    <IntlMessage ident='user.signupTeamv2.email' />
                    {this.state.errors?.email && (
                      <span className='errormsglabel'>
                        <IntlMessage ident='user.signupTeam.msgInvalidEmail' />
                      </span>
                    )}
                  </div>
                  <div className='formfield'>
                    <InputAlt
                      type='text'
                      name='email'
                      size={10}
                      maxLength={100}
                      ref={this._references.inputEmail}
                      required
                      validations={['required', 'email']}
                      value={this.state.email}
                      onChange={this._onChangeInput.bind(this, 'email')}
                      onBlur={this._onBlurField.bind(this, 'email')}
                      className={this.state.errors?.email ? 'errormsg' : ''}
                    />
                  </div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>
                    <IntlMessage ident='user.signupTeamv2.phone' />
                  </div>
                  <div className='formfield'>
                    <InputAlt
                      type='text'
                      name='phone'
                      size={10}
                      maxLength={100}
                      ref={this._references.inputPhone}
                      required
                      value={this.state.phone}
                      onChange={this._onChangeInput.bind(this, 'phone')}
                      onBlur={this._onBlurField.bind(this, 'phone')}
                      className={this.state.errors?.phone ? 'errormsg' : ''}
                    />
                  </div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>
                    <IntlMessage ident='user.signupTeamv2.country' />
                  </div>
                  <div className='formfield'>
                    <div className='select signup'>
                      <div className='selectsingle'>

                        <div className='selectinput selectinput_alt' style={{ padding: '4px 9px' }}>

                          <select
                            name='country'
                            value={CODE_TO_COUNTRY[this.state.country]}
                            onChange={(e) => {
                              this._onChangeInput('country', COUNTRY_TO_CODE[e.target.value])
                            }} style={{ border: 'none', background: 'transparent', width: '100%', height: '100%', cursor: 'pointer', outline: 'none' }}
                          >
                            {
                              this.data.countries.map(country =>
                                <option key={country.value} value={CODE_TO_COUNTRY[country.value]}>
                                  {IntlUtil.convertMessage(country.label)}
                                </option>)
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='formrow'>
                  <div className='formlabel'>
                    <IntlMessage ident='user.signupTeamv2.password' />
                    {this.state.errors?.password && (
                      <span className='errormsglabel'>
                        <IntlMessage ident='user.signupTeam.msgInvalidPassword' />
                      </span>
                    )}
                  </div>
                  <div className='formfield'>
                    <InputAlt
                      type='password'
                      name='password'
                      size={10}
                      maxLength={100}
                      ref={this._references.inputPassword}
                      required
                      validations={['required', 'password']}
                      value={this.state.password}
                      onChange={this._onChangeInput.bind(this, 'password')}
                      className={this.state.errors?.password ? 'errormsg' : ''}
                      onBlur={this._onBlurField.bind(this, 'password')}
                    />
                  </div>
                  <div className={`forminfo ${this.state.errors?.password && 'errormsg'}`}>
                    <IntlMessage ident='user.signupTeamv2.passwordInfo' />
                  </div>
                </div>
                <div className='formrow'>
                  <div className={`terms ${this.state.errors?.termsAgree && 'error'}`}>
                    <Checkbox
                      icon='login'
                      checked={this.state.bTermsAgree}
                      onChange={this._onChangeInput.bind(this, 'bTermsAgree')}
                    />

                    <div className={`label${bTermsAgreeError ? ' error' : ''}`}>
                      <span className='info'>
                        <IntlMessage ident='user.signupTeam.termsAndConditionInfo' />
                      </span>
                      <a
                        className='info alt'
                        href='/common/terms_and_conditions_rodeo_software.pdf'
                        target='_blank'
                      >
                        <IntlMessage ident='user.signupTeam.termsOfServicesLabel' />
                      </a>
                      <a
                        className='info alt'
                        href='/common/dpa_rodeo_software.pdf'
                        target='_blank'
                      >
                        <IntlMessage ident='user.signupTeam.dpaLabel' />
                      </a>
                      <a
                        className='info alt'
                        href='/common/privacy_policy_rodeo_software.pdf'
                        target='_blank'
                      >
                        <IntlMessage ident='user.signupTeam.privacyPolicyLabel' />
                      </a>
                    </div>
                  </div>
                </div>
                <div className='formact'>
                  <button
                    type='submit'
                    className={submitClasses}
                    disabled={isButtonDisabled}
                  >
                    <IntlMessage ident='user.signupTeamv2.submit' />
                  </button>
                  <p>
                    <IntlMessage ident='user.signupTeamv2.alreadyGottenAccount' /> <a href='/login'><IntlMessage ident='user.signupTeamv2.loginHere' /></a>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default SignupTeamContentv2
